export enum ChartOption {
  ShowBarChart = "ShowBarChart",
  ShowSankey = "ShowSankey",
  ShowGrid = "ShowGrid",
}